<section class="certificate-partner-section">
  <div class="box">
    <div class="box-left">
      <div class="box-left__content">
        <h2 class="content-title"
          ><span>{{ 'BECOME_OUR_PARTNER.CERTIFICATE_PARTNER.HEADING' | translate }}</span></h2
        >
        <div class="content-detail"
          ><span> {{ 'BECOME_OUR_PARTNER.CERTIFICATE_PARTNER.DETAIL' | translate }}</span></div
        >
        <div class="content-promotion"
          ><span>{{ 'BECOME_OUR_PARTNER.CERTIFICATE_PARTNER.PROMOTION' | translate }}</span></div
        >
      </div>

      <div class="box-left__wrapper">
        <ng-container *ngFor="let item of mockList; let index = index">
          <div class="box-left__wrapper--card">
            <div class="card-heading" [ngClass]="getColor(index)"
              ><span>{{ item.heading }}</span></div
            >

            <div class="card-pricing">
              <span>{{ item.pricing }}</span></div
            >
          </div>
        </ng-container>
      </div>
      <div class="box-link">
        <a
          class="hover-underline-text"
          href="https://www.flowaccount.com/{{ translate.currentLang }}/seminars"
          rel="noopener noreferrer"
          target="_blank"
        >
          <span>{{ 'BECOME_OUR_PARTNER.CERTIFICATE_PARTNER.BTN_COURSE' | translate }}</span></a
        >&nbsp;<i class="fas fa-angle-right"></i>
      </div>
    </div>

    <div class="box-right">
      <picture>
        <source
          srcset="
            https://flowaccountcdn.com/new_landing/image/accountingfirm/become-our-partner/partner_certificated_v1.webp
          "
          type="image/webp"
        />
        <img
          src="https://flowaccountcdn.com/new_landing/image/accountingfirm/become-our-partner/partner_certificated_v1.jpg"
          width="100%"
          loading="lazy"
          alt="คอร์สใบเซอร์สำหรับนักบัญชี"
          title="คอร์สใบเซอร์สำหรับนักบัญชี"
          class="box-right__image"
        />
      </picture>
    </div>
  </div>
</section>
